// the select box Alpine object
window.appSelect = (name, initialLabel, items) => {
    return {
        name,
        initialLabel,
        items,
        label: '',
        expanded: false,
        value: 0, // used for internal use only, value is held in the store
        init: function() {
            this.label = this.initialLabel;
        },
        set: function(item) {
            this.value = item.value;

            // if this is a nested object as part of inputs, or just a plain store object
            if( this.name.includes('inputs.')) {
                const parts = this.name.split('.');
                this.$store.inputs.set(parts[1], item.value);
            } else {
                this.$store[this.name] = item.value;
            }
            this.label = item.label;
        },
        clear: function() {
            // clear the value to either a 0 or empty string
            this.value = isNaN(this.value) ? '' : 0;
            // if this is a nested object as part of inputs, or just a plain store object
            if(this.name.includes('inputs.')) {
                const parts = this.name.split('.');
                this.$store.inputs.set(parts[1], this.value);
            } else {
                this.$store[this.name] = this.value;
            }
            // update the label
            this.label = this.initialLabel;
        }
    }
};
